$.account = {
	callback: {
		getAll: {
			success: function(data) {
				$.each(data.content, function(index, value) {
					$(document.createElement('tr'))
					.append(
						$(document.createElement('td'))
						.html(value.Id)
					)
					.append(
						$(document.createElement('td'))
						.html(value.Name)
					)
					.append(
						$(document.createElement('td'))
						.html(value.Email)
					)
					.append(
						$(document.createElement('td'))
						.html(value.Phone)
					)
					.append(
						$(document.createElement('td'))
						.addClass('text-right')
						.html(value.TicketFee)
					)
					.append(
						$(document.createElement('td'))
						.html(value.Rank)
					)
					.append(
						$(document.createElement('td'))
						.addClass('text-right')
						.append(
							$(document.createElement('a'))
							.addClass('btn btn-default btn-xs')
							.attr({
								'href' : '/json/admin/users/changeAccess/' + value.Id,
								'data-toggle' : 'tooltip',
								'title' : 'Log på denne bruger',
							})
							.append(
								$(document.createElement('i'))
								.addClass('fa fa-user-secret')
							)
						)
						.append(' ')
						.append(
							$(document.createElement('a'))
							.addClass('btn btn-default btn-xs')
							.attr({
								'href' : '/action/admin/users/update/' + value.Id,
								'title' : 'Rediger',
								'data-toggle' : 'modal',
								'data-target' : '#modalDialog'
							})
							.append(
								$(document.createElement('i'))
								.addClass('fa fa-pencil')
							)
						)
					)
					.appendTo('#contentList');
				});

				onDocumentStart();
			}
		},

		update: {
			success: function(data) {
				$('#modalDialog').modal('hide');
				$.account.pull.getAll();
			}
		}
	},

	push: {
		login: function() {
			$.post("/json/account/login", {
				'email' : $('#accountEmail').val(),
				'password' : $('#accountPassword').val(),
			}, function(data) {
				if ( data.status == 200 ) {
					location.href = '/';
				} else {
					alert('Error');
				}
			},'json');
		},

		update: function(accountId) {
			$('#dialogToolbar').ajax_callback('/json/admin/users/update', {
				'accountId' : accountId,
				'accountName' : $('#accountName').val(),
				'accountEmail' : $('#accountEmail').val(),
				'accountPhone' : $('#accountPhone').val(),
				'accountRank' : $('#accountRank').val(),
				'accountActivated' : $('#accountActivated:checked').val(),
				'accountTicketFee' : $('#accountTicketFee').val(),
			}, {
				alertToolbar: false,
				callback_success: $.account.callback.update.success
			});
		}
	},

	pull: {
		getAll: function() {
			$('#contentList').empty();

			$('#dialogToolbar').ajax_callback('/json/admin/users/getAll', {
			}, {
				alertToolbar: false,
				callback_success: $.account.callback.getAll.success
			});
		}
	}
};

$(document).bind('pull-account-getAll:ready',function() {	$.account.pull.getAll(); });
